import {createRef, useContext} from 'react';
import PaginationButton from './PaginationButton';
import styles from './PaginationNavigation.module.css';
import ScrollSpy from 'react-scrollspy-navigation';

export default function PaginationNavigation() {
    return (
        <div className={styles.container}>
            <ScrollSpy>
                <PaginationButton href="#box-1" text="Box 1" ref={createRef()}/>
                <PaginationButton href="#box-2" text="Box 2" ref={createRef()}/>
                <PaginationButton href="#box-3" text="Box 3" ref={createRef()}/>
                <PaginationButton href="#box-4" text="Box 4" ref={createRef()}/>
                <PaginationButton href="#box-5" text="Box 5" ref={createRef()}/>
                <PaginationButton href="#box-6" text="Box 6" ref={createRef()}/>
                <PaginationButton href="#box-7" text="Box 7" ref={createRef()}/>
                {/*<PaginationButton href="#box-8" text="Box 8" ref={createRef()}/>*/}
            </ScrollSpy>
        </div>
    );
}